<template>
  <div class="wap-p">
    <div class="card-list">
      <div
        :class="login ? 'card card-login card' + type : 'card card' + type"
        v-for="(item, id) in data"
        :key="id"
        @click.stop="cardClick(item)"
      >
        <div class="goods">
          <img v-if="item.isVilocal" class="brand-vilocal" src="@/assets/img/product/product-vilocal.png"/>
          <img :class="{'img-width':getImgAbbr(item.img),'img-height':!getImgAbbr(item.img)}" :src="item.img" />
          <div v-if="isShowAddToCart" class="action-area">
            <!-- <h4 v-if="item.imported == 1 || idlist.indexOf(item.id) >= 0">
              <i class="el-icon-check"></i>
              dropship List
            </h4>
            <h4 @click="importList(item.id)" v-loading="loading" v-else>
              <i class="el-icon-plus"></i>
              dropship list
            </h4> -->

            <h4 @click.stop="addCart(item)" class="wholesale">
              <i class="el-icon-plus"></i>
              Add to cart
            </h4>
          </div>
        </div>
        <p class="h5">{{ item.title }}</p>

        <!-- <p>
          <span>{{ item.stockNum.toLocaleString() }} in Stock</span>
          <span>Lists: {{ item.importCount.toLocaleString() }}</span>
        </p> -->
        <div class="not_login_lock" v-if="!login">
          <el-tooltip
            class="item"
            effect="dark"
            content="Sign Up for ShopVidi to unlock wholesale price"
            placement="top"
          >
            <img style="object-fit: cover;width: 10px;" src="../../assets/img/lock1.png" />
          </el-tooltip>
          <span class="lock_content">See the wholesale price</span>
        </div>
        <div class="h3" v-if="login || showWholesalePrice" :class="item.isVilocal&&item.wspStr.indexOf('~')>0&&item.brandVilocalType!=4?'flex-col':''">
          <span class="wholesale-price" v-if="item.isVilocal && item.brandVilocalType==4">
            ${{(Number(item.discountTrialRate)*Number(item.wspStr.split('~')[0])).toFixed(2)}}
          </span>
          <span class="wholesale-price" :class="(item.isVilocal&&item.brandVilocalType==4) && 'original-price' ">
               ${{ item.isVilocal&&item.brandVilocalType==4?item.wspStr.split('~')[0]:item.wspStr.toLocaleString() }}
          </span>
          <span class="wholesale-price-span" >Wholesale Price</span>
        </div>

        <div class="h3" v-if="login || showReailPrice" :class="!item.isVilocal&&item.rrpStr.indexOf('~')>0&&item.brandVilocalType!=4?'flex-col':''">
<!--          <span class="price_h3">${{ item.rrpStr.toLocaleString().indexOf("~")>0?item.rrpStr.toLocaleString().split("~")[0]:item.rrpStr.toLocaleString() }}</span>-->
          <span class="price_h3">${{ (item.isVilocal&&item.brandVilocalType==4)?item.rrpStr.split('~')[0]:item.rrpStr.toLocaleString() }}</span>
          <span class="price_name">Suggested Retail Price</span>
        </div>

        <!-- 从首页来 --->
        <template>
          <!-- <div v-if="item.salesManager && isMobile" class="top_brand_mobile">Top Brand</div> -->
          <div v-if="isShowBrandTag" :class="isShowBrandTag && (item.brandIsVilocal || item.salesManager)?'brand-tag':'none-brand-tag'">
            <div v-if="item.brandIsVilocal" class="vilocal">ViLocal</div>
            <div v-if="item.salesManager" class="top_brand">Top Brand</div>
          </div>
          <div
            class="h2"
            v-if="item.collectionBrandName"
            @click.stop="
              $router.push({
                  name: 'brand',
                params: {
                  brandName: item.collectionBrandSeoUrl.substr(1),
                },
              })
            "
          >
            <img :src="item.collectionBrandUrl" alt="" class="brand_img_url" />
            <p>By {{ item.collectionBrandName }}</p>
            <!-- <div v-if="item.salesManager && !isMobile" class="top_brand">Top Brand</div> -->
          </div>
        </template>
      </div>
    </div>

    <!-- 添加到购物车 -->
    <el-dialog :visible.sync="visible" @close="closeDialog" :append-to-body="true">
      <div class="dia-content">
        <div class="left-content">
          <img class="img-responsive" :src="diaObj.imgUrl" />
        </div>
        <div class="right-content" v-if="!isMobile">
          <p>{{ diaObj.title }}</p>
          <p>
            <span class="wholesale-price">${{ diaObj.price }}</span>
            <span class="wholesale-price-span">Wholesale Price</span>
          </p>
          <p>
            <span>${{ diaObj.netPrice }}</span>
            <span class="p-span">Suggested Retail Price</span>
          </p>

          <!-- 此种方式无法做成动态的级联，故更改为后面的 -->
          <!--                <template v-for="(obj, no) in skuAttributeMap" >
                  <template v-for="(arr, key) in obj">
                    <p> {{ key}}</p>
                    <p>
                       <el-select v-model="selObj['s_'+no]" no-data-text="No data" :key="no" placeholder="Please select" @change="changeSkuAttr($event,no)">
                           <el-option
                                v-for="item in arr"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                           </el-option>
                       </el-select>
                    </p>
                   </template>
                </template>-->
          <template v-if="attObj.att0Flag">
            <p>{{ attObj.att0Name }}</p>
            <p>
              <el-select
                v-model="selObj['s_0']"
                no-data-text="No data"
                placeholder="Please select"
                @change="changeSkuAttr($event, 0, attObj.att0Name)"
              >
                <el-option
                  v-for="item in attObj.att0Arr"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </p>
          </template>
          <template v-if="attObj.att1Flag">
            <p>{{ attObj.att1Name }}</p>
            <p>
              <el-select
                v-model="selObj['s_1']"
                no-data-text="No data"
                placeholder="Please select"
                @change="changeSkuAttr($event, 1, attObj.att1Name)"
              >
                <el-option
                  v-for="item in attObj.att1Arr"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </p>
          </template>
          <template v-if="attObj.att2Flag">
            <p>{{ attObj.att2Name }}</p>
            <p>
              <el-select
                v-model="selObj['s_2']"
                no-data-text="No data"
                placeholder="Please select"
                @change="changeSkuAttr($event, 2, attObj.att2Name)"
              >
                <el-option
                  v-for="item in attObj.att2Arr"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </p>
          </template>
          <template v-if="attObj.att3Flag">
            <p>{{ attObj.att3Name }}</p>
            <p>
              <el-select
                v-model="selObj['s_3']"
                no-data-text="No data"
                placeholder="Please select"
                @change="changeSkuAttr($event, 3, attObj.att3Name)"
              >
                <el-option
                  v-for="item in attObj.att3Arr"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </p>
          </template>
          <div class="style_quantity">
            <p>Quantity</p>
            <p v-if="goodCase>1">（Case size {{goodCase}}）</p>
          </div>
          <p class="cust-num">
            <el-input-number
              v-model="diaObj.num"
              :min="moq > goodCase ? moq : goodCase"
              size="medium"
              :step="goodCase?goodCase:1"
              @change="changeQuantity"
            ></el-input-number>
          </p>
          <div class="inactive-sku" v-if="!skuIsExists">Unavailable</div>
          <div class="inactive-sku" v-else-if="diaObj['status']=='2' && skuIsExists">Sold Out</div>
          <div class="out-of-stock" v-else-if="diaObj['status']=='0' && skuIsExists" >
              <div>This item is temporarily out of stock，restock by {{diaObj['restockDate']}}</div>
              <div class="cart-btn">Out of Stock</div>
          </div>
          <div class="cart-btn" @click="addToCar" v-else>Add to Cart</div>

        </div>
        <!-- 手机端显示 begin-->
        <div class="right-content-mobile" v-else>
          <p>{{ diaObj.title }}</p>
          <p>
            <span class="p-span">Retail Price</span>
            <span>${{ diaObj.netPrice }}</span>
          </p>
          <p>
            <span class="p-span">Wholesale Price</span>
            <span>${{ diaObj.price }}</span>
          </p>
          <!--              <p class="sku-attr" v-for="(arr, key, no) in skuAttributeMap" :key="key">
                <span>{{ key }}</span>
                <el-select v-model="selObj['s_'+no]" no-data-text="No data" placeholder="Please select" @change="changeSkuAttr($event,no)">
                  <el-option
                    v-for="item in arr"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
              </p>-->
          <p class="sku-attr" v-if="attObj.att0Flag">
            <span>{{ attObj.att0Name }}</span>
            <el-select
              v-model="selObj['s_0']"
              no-data-text="No data"
              placeholder="Please select"
              @change="changeSkuAttr($event, 0, attObj.att0Name)"
            >
              <el-option
                v-for="item in attObj.att0Arr"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </p>
          <p class="sku-attr" v-if="attObj.att1Flag">
            <span>{{ attObj.att1Name }}</span>
            <el-select
              v-model="selObj['s_1']"
              no-data-text="No data"
              placeholder="Please select"
              @change="changeSkuAttr($event, 1, attObj.att1Name)"
            >
              <el-option
                v-for="item in attObj.att1Arr"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </p>
          <p class="sku-attr" v-if="attObj.att2Flag">
            <span>{{ attObj.att2Name }}</span>
            <el-select
              v-model="selObj['s_2']"
              no-data-text="No data"
              placeholder="Please select"
              @change="changeSkuAttr($event, 2, attObj.att2Name)"
            >
              <el-option
                v-for="item in attObj.att2Arr"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </p>
          <p class="sku-attr" v-if="attObj.att3Flag">
            <span>{{ attObj.att3Name }}</span>
            <el-select
              v-model="selObj['s_0']"
              no-data-text="No data"
              placeholder="Please select"
              @change="changeSkuAttr($event, 3, attObj.att3Name)"
            >
              <el-option
                v-for="item in attObj.att3Arr"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </p>

          <p class="cust-num">
            <span>Quantity</span
            ><el-input-number
              v-model="diaObj.num"
              :min="moq > goodCase ? moq : goodCase"
              size="medium"
              :step="goodCase?goodCase:1"
              @change="changeQuantity"
            ></el-input-number>
          </p>
          <p v-if="goodCase>1" class="qty_num">（Case size1 {{goodCase}}）</p>
          <div class="inactive-sku" v-if="!skuIsExists">Unavailable</div>
          <div class="inactive-sku" v-else-if="diaObj['status']=='2' && skuIsExists">Sold Out</div>
          <div class="out-of-stock" v-else-if="diaObj['status']=='0' && skuIsExists" >
              <div>This item is temporarily out of stock，restock by {{diaObj['restockDate']}}</div>
              <div class="cart-btn">Out of Stock</div>
          </div>
          <div class="cart-btn" @click="addToCar" v-else>Add to Cart</div>
        </div>
        <!-- end手机端显示 -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import publicFn from '@/utils/index'
import { postAction, getAction } from '@/api/manage.js'
export default {
  name: 'Head',
  props: {
    isShowBrandTag: {
      type: Boolean
    },
    data: {
      type: Array
    },
    showLogin: {
      type: Function
    },
    clickHandle: {
      type: Function
    },
    contentType: {
      type: String,
      default: 'default' // 展示类型 是否有物流信息  shopping--都有 onlyOff--只有off字段 default--都没有
    },
    type: {
      type: Number,
      default: 5// 显示列数
    },
    setShowAn: {
      type: Function
    },
    source: {
      type: String
    },
    spu: {
      type: Object,
      default: function() {
        return {}
      }
    },
    isShowAddToCart: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      goodCase: '',
      loading: false,
      visible: false,
      selSkuStr: undefined, // 选择的sku信息
      goodsId: '',
      skuId: '',
      diaObj: {},
      url: {
        skuCharacterUrl: 'tsgoods/tsGoodsInfo/sku_character', // 特征url
        storeskuCharacterUrl: 'store/tsGoodsInfo/sku_character' // 店铺特征url
      },
      selObj: {
        s_0: '',
        s_1: '',
        s_2: '',
        s_3: ''
      },
      attObj: {
        att0Flag: false,
        att1Flag: false,
        att2Flag: false,
        att3Flag: false,
        att0Name: '',
        att1Name: '',
        att2Name: '',
        att3Name: '',
        disName: '',
        changeCurIdx: '',
        att0Arr: [],
        att1Arr: [],
        att2Arr: [],
        att3Arr: [],
        attV0: '',
        attV1: '',
        attV2: '',
        attV3: '',
        attV4: ''
      },
      idlist: [],
      skuAttributeMap: null,
      skuAttStrWithSkuIdMap: new Map(), // sku特征id字符串与skuId Map
      skuIdWithSkuMap: new Map(), // skuId与对象map
      parentIdWithSonListMap: new Map(), // 父类ID与后续List map
      showReailPrice: false,
      showWholesalePrice: false,
      currentClickBrandFlag: false,
      skuIsExists: true,
      existsMultipleCharacteristic: false, // 存在多组特征
      isChangeGroup: false, // 是否手动更改过特征组下拉框
      maxCharacteristicGroupCount: 0 // 组最大索引
    }
  },
  created() {
    // TODO haoyuanw 20220409 hotfix 查询在不登录的情况下显示哪个价格
    this.getSimpleConfiguration()
    if (this.spu && JSON.stringify(this.spu) !== '{}') {
      this.addCart(this.spu)
    }
  },
  watch: {
    spu: {
      handler(n, o) {
        if (n !== o) {
          this.addCart(n)
        }
      }
    },
    attObj: {
      // 此处只需要监听sku属性对象变化即可，无需知道具体值发生变化。
      handler(val, oldVal) {
        this.selSkuStr = ''
        this.selSkuStr = ''
        let tmpArr = []

        for (let k in val) {
          if (val[k] != '' && k.indexOf('V') > 0) {
            tmpArr.push(val[k])
          }
        }

        // 赋值后续下拉框
        let sonList = this.parentIdWithSonListMap.get(val.disName)
        sonList = !sonList ? [] : sonList
        switch (val.changeCurIdx) {
          case 0:
            this.selObj.s_1 = ''
            this.selObj.s_2 = ''
            val.att1Arr = sonList

            break
          case 1:
            this.selObj.s_2 = ''
            this.selObj.s_3 = ''
            val.att2Arr = sonList

            break
          case 2:
            this.selObj.s_3 = ''
            val.att3Arr = sonList
            break
        }

        this.selSkuStr = tmpArr.join('—')

        let skuId = this.skuAttStrWithSkuIdMap.get(this.selSkuStr)
        if (skuId === null || skuId === '' || skuId === undefined) {
          this.selSkuStr = tmpArr.reverse().join('—')
        }
        this.switchSku()
      },
      deep: true // true 深度监听
    },
    'diaObj.id': {
      handler(val, oldVal) {},
      deep: true
    },
    $route(to, from) {

    }

  },
  computed: {
    isMobile() {
      const isMob = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return isMob
    }
  },
  // mounted() {
  //   console.log(props,'31231')
  // },
  methods: {
    getImgAbbr(fileDetail) {
      const preImgtemp = fileDetail
      let imgObject = this.getImgSize(preImgtemp)
      return imgObject.width > imgObject.height
    },
    async getImgSize (url) {
      return new Promise((resolve, reject) => {
        let imgObj = new Image()
        imgObj.src = url
        imgObj.onload = () => {
          resolve({
            width: imgObj.width,
            height: imgObj.height
          })
        }
      })
    },
    getSimpleConfiguration() {
      getAction('/simple/configuration/group?group=not_logged_in').then(
        (response) => {
          if (response.success) {
            if (response.result) {
              for (var index = 0; index < response.result.length; index++) {
                const element = response.result[index]
                if (element.configurationKey === 'wholesale_price') {
                  if (element.configurationValue === '0') {
                    this.showWholesalePrice = false
                  } else {
                    this.showWholesalePrice = true
                  }
                }
                if (element.configurationKey === 'retail_price') {
                  if (element.configurationValue === '0') {
                    this.showReailPrice = false
                  } else {
                    this.showReailPrice = true
                  }
                }
              }
            }
          } else {
            this.$message.warning(response.message)
          }
        }
      )
    },
    /**
     * 添加到购物车
     */
    addCart(item) {
      if (!this.login) {
        // modify by cpgu 2022/05/15 添加以下if else（手机端如果没有登陆，则直接跳转到详情页） begin
        if (this._isMobile()) {
          this.cardClick(item)
        } else {
          this.$emit('showLogin', item)
        }
        // end by cpgu
        return ''
      }

      this.isChangeGroup = false
      this.skuIsExists = true

      this.goodsId = item.id
      this.diaObj = { ...item, num: 1 }

      // 未删除SKU，并且是有效状态SKU
      let activeSkuArr = []
      if (this.diaObj.skus) {
        activeSkuArr = this.diaObj.skus.filter(f => !f['isDeleted'] && f['status'] == '1')
      }

      // sku特征
      let activeSku = (activeSkuArr && activeSkuArr.length > 0) ? activeSkuArr[0] : {}
      this.loadSkuCharacterUrl(this.goodsId, activeSku)

      // sku信息
      let skuMap = new Map()
      let skuArr = this.diaObj.skus
      for (const skuArrElement of skuArr) {
        skuMap.set(skuArrElement.id + '', skuArrElement) // id转化为字符串
      }
      this.skuIdWithSkuMap = skuMap

      this.selSkuStr = '' // 清空
      this.attObj = { attV0: '', attV1: '', attV2: '', attV3: '', attV4: '' }
      this.selObj = {}
      this.skuId = ''
      this.selSkuStr = '' // 清空
      this.attObj = {
        att0Flag: false,
        att1Flag: false,
        att2Flag: false,
        att3Flag: false,
        att0Name: '',
        att1Name: '',
        att2Name: '',
        att3Name: '',
        attV0: '',
        attV1: '',
        attV2: '',
        attV3: '',
        attV4: ''
      }
      this.selObj = { s_0: '', s_1: '', s_2: '', s_3: '' }
      this.skuId = ''

      this.visible = true
    },
    addToCar: publicFn.debounce(function (data) {
      if (!this.skuId) {
        this.$message.info('Please select a SKU')
        return
      }
      const formData = [
        {
          goodsId: this.goodsId,
          goodsStatus: 1,
          num: this.diaObj.num,
          skuId: this.skuId
        }
      ]
      this.closeDialog()
      // TODO haoyuanw add 2021-11-11 这里判断是哪个路由过来的
      // eslint-disable-next-line no-undef
      mixpanel.track('v_wholealse_bag', { product_id: this.goodsId })
      this.loading = true
      postAction('/order/cart/add', formData)
        .then((res) => {
          if (res.success) {
            this.loading = false
            this.$message.success(res.message)
            // TODO haoyuanw add 2021-09-15 GA
            // eslint-disable-next-line no-undef
            gtag('event', 'click', {
              event_category: 'addcart'
            })
            // haoyuanw add 2021-10-21 当加入购物车时调用PB
            // eslint-disable-next-line no-undef
            fbq('track', 'AddToCart')
            // haoyuanw add 2023-08-15 klaviyo 增加加购推送数据
            const skuObj = this.skuIdWithSkuMap.get(this.skuId)
            let categoryObject = {}
            this.diaObj.categories.forEach(element => {
              if (element.cateLevel === 1) {
                categoryObject.firstCategory = element
              } else if (element.cateLevel === 2) {
                categoryObject.secondCategory = element
              } else if (element.cateLevel === 3) {
                categoryObject.thirdCategory = element
              }
            })
            const addToCartObject = {
              '$value': this.diaObj.num * this.diaObj.price,
              'AddedItemProductName': this.diaObj.title,
              'AddedItemProductID': this.diaObj.id,
              'AddedItemCategories': categoryObject,
              'AddedItemURL': window.location.origin + '/product' + this.diaObj.seoUrl,
              'AddedItemPrice': this.diaObj.price,
              'AddedItemQuantity': this.diaObj.num,
              'Items': {
                'ProductID': this.diaObj.id,
                'SKU': skuObj.vdSku,
                'ProductName': this.diaObj.title,
                'Quantity': this.diaObj.num,
                'ItemPrice': this.diaObj.price,
                'RowTotal': this.diaObj.num * this.diaObj.price,
                'ProductURL': window.location.href,
                'ImageURL': this.diaObj.imgUrl,
                'ProductCategories': categoryObject
              }
            }
            console.log(addToCartObject)
            klaviyo.push(['track', 'Added to Cart', addToCartObject])
          } else {
            this.$message.warning(res.message)
          }
        })
        .finally(() => {})
    }, 300),
    importList(goodId) {
      // 这里不需要判断，因为在请求如果提示 Token 失效 则会在response过滤器进行处理
      // const loading = this.$loading({
      //   body: true,
      //   text: 'Loading',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(255, 255, 255, 0.3)'
      // })

      if (!this.login) {
        /* this.$message({
          message: 'Please log in to ShopVidi',
          type: 'info',
          duration: 2 * 1000
        }) */
        this.$emit('showLogin')
        return
      }
      this.loading = true
      let goodIds = []
      // this.$emit('setShowAn');
      goodIds.push(goodId)
      const params = { goodIds: goodIds, themeId: null }
      postAction('/store/tsStoreGoodsInfo/importList', params)
        .then((response) => {
          if (response.success) {
            this.$message.success(response.message)
            this.loading = false
            this.idlist.push(goodId)
            getAction('/store/tsStoreGoodsInfo/import/list', {
              sync_status: 0,
              pageNo: 1,
              pageSize: 10
            }).then((res) => {
              if (res.success) {
                let value = res.result && res.result.total
                localStorage.setItem('num', value)
                this.$emit('setShowAn', value)
              } else {
                this.$message.warning(response.message)
                this.loading = false
              }
            })
            // loading.close()
          } else {
            this.$message.warning(response.message)
            this.loading = false
            // loading.close()
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    getEnvUrl() {
      let href = window.location.href
      let url = window.location.host
      if (href.indexOf('test') >= 0) {
        url = location.origin
        return url
      }
      if (href.indexOf('localhost') >= 0) {
        url = location.origin
        return url
      }
      if (href.indexOf('pre') >= 0) {
        url = location.origin
        return url
      }
      if (href.indexOf('shopvidi') >= 0) {
        url = location.origin
        return url
      }
      if (href.indexOf('192') >= 0) {
        url = location.origin
        return url
      }
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },
    clickBrand(data) {
      this.currentClickBrandFlag = true
      location.href = 'brand' + data.collectionBrandSeoUrl
    },
    cardClick(data) {
      if (this.source === 'home' && this.currentClickBrandFlag) {
        return
      }
      //  2.2.0 增加逻辑如果是 详情点击的就调用父组件推送埋点信息
      if (this.$route.name === 'product') {
        this.$emit('buryingPoint', data)
      }
      // console.log('当前商品的信息',source,'1111')
      let be = this.getEnvUrl() // 'http://192.168.3.54:3000'
      // if (this.login) {
      if (data.seoUrl) {
        // 判断当前处于哪个路由
        localStorage.setItem('id', data.id)
        // const productName = data.title.replaceAll(" ", "_").slice(0, 60);
        if (this.$route.path === '/') {
          // TODO haoyuanw add 2022-01-04  判断移动端和pc端采取不用打开方式 start
          if (!this._isMobile()) {
            let newTab = window.open()
            newTab.location.href =
                be + '/product' + data.seoUrl
            return
          }
          // 这里面直接显示 Home -> title 不需要任何参数
          this.$router.push({
            /*   name: 'product',
            params: { url: data.seoUrl} */
            // path: '/product',
            // query:{ flag:11}
            path: '/product' + data.seoUrl

          })
        } else if (this.$route.name === 'search') {
          if (!this._isMobile()) {
            let newTab = window.open()
            newTab.location.href =
                be + '/product' + data.seoUrl
            return
          }
          // 如果是查询页面来的话，需要传参数以及关键字
          this.$router.push({
            path: '/product' + data.seoUrl
            // path: '/product',
            // query:{ flag:11,keyWords: this.$route.params.value}
          })
        } else if (this.$route.name === 'category' || this.$route.name === 'collection') {
          // 传级别最低的id
          if (
            this.$route.params.thirdId !== undefined &&
              this.$route.params.thirdId !== null
          ) {
            if (!this._isMobile()) {
              let newTab = window.open()
              newTab.location.href =
                  be + '/product' + data.seoUrl
              return
            }
            this.$router.push({
            /*  name: 'product',
              params: {
                url: data.seoUrl
              } */
              // path: '/product',
              // query:{ flag:13}
              path: '/product' + data.seoUrl

            })
          } else if (
            this.$route.params.secondId !== undefined &&
              this.$route.params.secondId !== null
          ) {
            if (!this._isMobile()) {
              let newTab = window.open()
              newTab.location.href =
                  be + '/product' + data.seoUrl
              return
            }
            this.$router.push({
              /* name: 'product',
              params: {
                url: data.seoUrl
              } */
              // path: '/product',
              // query:{ flag:13}
              path: '/product' + data.seoUrl

            })
          } else {
            if (!this._isMobile()) {
              let newTab = window.open()
              newTab.location.href =
                  be + '/product' + data.seoUrl
              return
            }
            this.$router.push({
              // name: 'product',
              // params: {
              //   url: data.seoUrl
              // }
              path: '/product' + data.seoUrl
            })
          }
        } else if (this.$route.name === 'brand') {
          // 传级别最低的id
          if (!this._isMobile()) {
            let newTab = window.open()
            newTab.location.href =
                be + '/product' + data.seoUrl
            return
          }
          this.$router.push({
          /*  name: 'product',
            params: {
              url: data.seoUrl
            } */
            // path: '/product',
            // query:{ flag:14,brandId: this.$route.params.id,value: this.$route.params.value}
            path: '/product' + data.seoUrl

          })
        } else if (this.$route.name === 'product') {
          window.location.href = window.location.origin + '/product' + data.seoUrl
          // this.$router.push({path: '/product' + data.seoUrl})
        }
      }
      // window.open(this.$tokenUrl(_url, false))
      // } else {
      // 判断是从商品页登录
      // this.$emit("showLogin");
      // gtag("event", "click", {
      //   event_category: "product_signin_up",
      // });
      // this.$message('Please log in to ShopVidi')
      // }
    },
    closeDialog() {
      this.visible = false
    },
    loadSkuCharacterUrl(goodsId, activeSku) {
      const that = this
      getAction(this.url.skuCharacterUrl, { id: goodsId }).then((res) => {
        if (res.success) {
          const result = res.result
          // 子级
          const attrWithSonListMap = result.attrWithSonListMap
          let tmpMap = new Map()
          for (let k in attrWithSonListMap) {
            tmpMap.set(
              k + '_' + attrWithSonListMap[k]._1,
              attrWithSonListMap[k]._2
            )
          }
          this.parentIdWithSonListMap = tmpMap
          // 动态判断下拉框
          const attributeObj = result.attribute
          let characterWithIdxObj = result.characterWithIdxMap

          // add by cpgu 判断是否存在多组特征，大于0，表示存在 2023/05/30
          let maxIdx = 0
          for (let k in characterWithIdxObj) {
            maxIdx = (parseInt(characterWithIdxObj[k]) > maxIdx) ? parseInt(characterWithIdxObj[k]) : maxIdx
          }
          this.existsMultipleCharacteristic = maxIdx > 0
          this.maxCharacteristicGroupCount = maxIdx
          // end by cpgu

          for (let k in characterWithIdxObj) {
            switch (parseInt(characterWithIdxObj[k])) {
              case 0:
                that.attObj.att0Flag = true
                that.attObj.att0Name = k
                for (const ak in attributeObj) {
                  if (ak == k) {
                    that.attObj.att0Arr = attributeObj[ak]
                    // 第一个下拉框默认选中第一个
                    this.attObj.disName = attributeObj[ak][0].value + '_' + k
                    this.attObj.attV0 = attributeObj[ak][0].value
                    this.attObj.changeCurIdx = 0
                    this.selObj.s_0 = attributeObj[ak][0].value

                    // 只有一组时，默认选中有效的SKU
                    if (!this.existsMultipleCharacteristic && activeSku) {
                      this.attObj.disName = activeSku['character'] + '_' + k
                      this.attObj.attV0 = activeSku['character']
                      this.attObj.changeCurIdx = 0
                      this.selObj.s_0 = activeSku['character']
                    }
                  }
                }
                break
              case 1:
                that.attObj.att1Flag = true
                that.attObj.att1Name = k
                break
              case 2:
                that.attObj.att2Flag = true
                that.attObj.att2Name = k
                break
              case 3:
                that.attObj.att3Flag = true
                that.attObj.att3Name = k
                break
              case 4:
                that.attObj.att4Flag = true
                that.attObj.att4Name = k
                break
            }
          }

          // sku组合key与skuId Map
          let attrSkuObj = result.attrSku
          let attrMap = new Map()
          for (let k in attrSkuObj) {
            attrMap.set(k, attrSkuObj[k].skuId)
          }
          that.skuAttStrWithSkuIdMap = attrMap
        }
        if (res.code === 510) {
          this.$message.warning(res.message)
        }
        // this.getTotalPrice()
      })
    },
    // 监听库存输入值的变化
    changeQuantity(value) {
      if (this.goodCase) {
        this.$nextTick(() => {
          this.diaObj.num = this.countTotal(value, this.goodCase)
        })
      } else {
        this.diaObj.num = value
      }
    },
    countTotal(n, base) {
      const x = n % base
      return x > 0 ? n - x + base : n
    },
    switchSku() {
      let skuId = this.skuAttStrWithSkuIdMap.get(this.selSkuStr)
      if (skuId) {
        this.skuIsExists = true
        this.skuId = skuId
        const skuObj = this.skuIdWithSkuMap.get(this.skuId)
        this.diaObj.imgUrl = skuObj.imgPath
        this.diaObj.title = skuObj.skuName
        this.diaObj.price = skuObj.price.toFixed(2)
        this.diaObj.netPrice = skuObj.netPrice.toFixed(2)
        this.diaObj.status = skuObj.status
        this.diaObj.restockDate = skuObj['restockDateFormat']
        // 2022-6-20新增case
        this.goodCase = skuObj.step
        this.moq = skuObj.moq
        // this.goodCase = 20
        this.diaObj.num = this.moq > this.goodCase ? this.moq : this.goodCase
        /* this.diaObj.aboutProfit = skuObj.profit//利润(约赚)
        this.diaObj.stockNum = skuObj.stockNum//库存
        this.diaObj.weight = skuObj.weight//重量
        */

        // 2.2.6 新增逻辑 选择sku后判断isSales字段 如果是false就显示不可用，不是false就是 加购
        if (skuObj.isSales || skuObj.isSales === null) {
          this.skuIsExists = true
        } else {
          this.skuIsExists = false
        }
      } else {
        // 主动改变过，并且每一组规格值都下拉更改过
        if (this.isChangeGroup && this.allChangesGroup()) {
          this.skuIsExists = false
        }
      }
    },
    allChangesGroup() {
      let flag = false
      switch (this.maxCharacteristicGroupCount) {
        case 0:
          flag = true
        case 1:
          flag = (this.selObj['s_0'] && this.selObj['s_1'])
          break
        case 2:
          flag = (this.selObj['s_0'] && this.selObj['s_1'] && this.selObj['s_2'])
          break
        case 3:
          flag = (this.selObj['s_0'] && this.selObj['s_1'] && this.selObj['s_2'] && this.selObj['s_3'])
          break
      }
      return flag
    },
    changeSkuAttr(v, no, disV) {
      this.attObj.disName = v + '_' + disV
      this.attObj.changeCurIdx = no
      this.isChangeGroup = true
      switch (no) {
        case 0:
          this.attObj.attV0 = v
          // 当第一个选项被更改后，skuID 和其他属性都要重置，以避免skuId还按照之前的选项保存和获取
          this.attObj.attV1 = ''
          this.attObj.attV2 = ''
          this.attObj.attV3 = ''
          this.attObj.attV4 = ''
          this.skuId = ''

          break
        case 1:
          this.attObj.attV1 = v
          break
        case 2:
          this.attObj.attV2 = v
          break
        case 3:
          this.attObj.attV3 = v
          break
        case 4:
          this.attObj.attV4 = v
          break
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.brand-vilocal{
  position: absolute;
  top: 0px;
  left:0px;
  width: 54.6px;
  height: 54.6px;
}
.none-brand-tag{
  display: flex;
  align-items: center;
}
.brand-tag{
  display: flex;
  align-items: center;
  margin: 5px 0px 10px 0px;
}
.vilocal{
  background: #F3E93D;
  border-radius: 3px;
  opacity: 1;
  width: 60px;
  height: 20px;
  font-size: 12px;
  font-family: Satoshi-Medium;
  line-height: 20px;
  margin-right: 10px;
  text-align: center;
}
.top_brand{
  width: 70px;
  height: 20px;
  background: #FFEBE5;
  border-color: #FFEBE5;
  border-radius: 3px;
  font-size: 12px;
  font-family: Satoshi;
  font-weight: 500;
  line-height: 20px;
  color: #FB541C;
  text-align: center;
}
div{
  font-family: Satoshi;
}
.qty_num{
  display: flex;
  justify-content: end;
  align-items: center;
  color: #5D5D5D;
}
.brand_img_url {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 5px;
  border: solid 1px #e1e1e1;
}
.el-divider--horizontal {
  margin: 10px 0;
}
.wholesale-price {
  font-size: 16px;
  font-weight: 600;
  font-family: Satoshi-Bold;
}
.wholesale-price-span {
  margin: 0 5px;
  line-height: 30px;
  color: #262613;
  font-size: 14px;
}
.card-list {
  position: relative;
  margin-left: 5px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;

  .more-card {
    position: relative;
    width: 100%;
    padding-top: 10px;
    margin-top: 10px;
    border-top: 1px solid #e1e1e1;
  }

  .card {
    position: relative;
    margin-right: 20px;
    // border: 1px solid #e1e1e1;
    padding-bottom: 5px;
    margin-bottom: 20px;
    cursor: pointer;
    b {
      color: #262b2f;
    }
    em {
      position: relative;
      width: calc(100% - 10px);
      margin: 0 auto 5px;
      display: flex;
      align-items: center;
      font-style: normal;
      img {
        width: 20px;
        margin-right: 3px;
      }
    }
    i {
      font-style: normal;
      color: #ff4812;
    }
    .h5 {
      width: calc(100% - 10px);
      margin: 10px 0;
      height: 42px;
      font-size: 16px;
      font-family: Satoshi;
      font-weight: 500;
      //line-height: 40px;
      color: #262613;
      display: -webkit-box;
      overflow: hidden;
      white-space: normal !important;
      text-overflow: ellipsis;
      word-wrap: break-word;
      -webkit-line-clamp: 2; //想展示几行
      -webkit-box-orient: vertical;
      text-align: left;
    }
    .h2 {
      display: flex;
      align-items: center;
      width: calc(100% - 10px);
      // margin: 0 auto;
      font-family: Satoshi-Medium;
      font-size: 14px;
      word-break: normal;
      p {
        font-style: normal;
        padding-left: 5px;
        margin-right: 10px;
        font-size: 14px;
        font-weight: 500;
        text-decoration: underline;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    p {
      position: relative;
      width: calc(100% - 10px);
      display: flex;
      // margin-left: 5px;
      font-size: 14px;
      justify-content: space-between;
      align-items: center;
      span {
        display: block;
        color: #8f8f8f;
      }
    }
    .not_login_lock{
      //width: calc(100% - 10px);
      margin: 0 auto;
      margin-top:5px;
      line-height: 20px;
      color: #262b2f;
      display: flex;
      align-items: center;
      .lock_content{
        margin-left:10px;
        font-size: 14px;
        font-weight: 400;
        line-height: 25px;
        color: #262613;
        opacity: 1;
      }
    }
    .h3 {
      width: calc(100% - 10px);
      // margin: 0 auto;
      line-height: 20px;
      color: #262b2f;
      display: flex;
      align-items: center;
      .price_h3 {
        font-size: 14px;
      }

      .price_name {
        margin: 0 5px;
        font-size: 14px;
        line-height: 30px;
        color: #5D5D5D;
      }
      i {
        font-style: normal;
      }
    }
  }

  .card-login {
  }
  .card1{
    margin-right: 10px;
    width: 100%;
  }
  .card5 {
    width: calc(20% - 20px);
    &:nth-child(5n) {
      margin-right: 0;
    }

  }
  .card4 {
    width: calc(25% - 20px);
    &:nth-child(4n) {
      margin-right: 0;
    }
  }
  .card3 {
    width: calc(33.33% - 20px);
    &:nth-child(3n) {
      margin-right: 0;
    }
    &:nth-last-child(1),
    &:nth-last-child(2),
    &:nth-last-child(3) {
      margin-bottom: 0;
    }
  }
  .goods {
    position: relative;
    width: 100%;
    height: 260px;
    overflow: hidden;
    text-align: center;
    .img-width{
      width: 100%;
    }
    .img-height{
      height: 100%;
    }
    // img {
    //   width: 100%;
    //   height: 100%;
    //   object-fit: cover;
    // }
    .action-area {
      width: 100%;
      h4 {
        transition: all 0.5s;
        position: absolute;
        left: 2%;
        bottom: -65px;
        height: 43px;
        width: 45%;
        background: #000000;
        border: 1px solid #000000;
        box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.05);
        font-size: 14px;
        text-align: center;
        font-weight: 500;
        line-height: 43px;
        i {
          color: #ffffff;
        }
        color: #ffffff;
      }
      .wholesale {
        transition: all 0.5s;
        position: absolute;
        // left: 51%;
        bottom: -65px;
        height: 43px;
        width: 95%;
        background: #F3E93D;
        border: 1px solid #F3E93D;
        box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.05);
        font-size: 14px;
        text-align: center;
        font-weight: 500;
        line-height: 43px;
        i {
          color: #262613;
        }
        color: #262613;
      }
    }
  }
  .card {
    &:hover {
      .goods h4 {
        bottom: 20px;
      }
    }
  }
}

/deep/ .el-dialog {
  width: 46%;
}
.dia-content {
  margin: 0 auto;
  padding: 50px 0;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  text-align: left !important;

  .left-content {
    border: 1px solid #e1e1e1;
    width: 300px;
    height: 300px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .right-content {
    width: 350px;
    margin-left: 30px;
    position: relative;
    color: #262b2f;
     p {
      line-height: 28px;
      &:nth-child(1) {
        font-size: 14px;
        font-weight: 500;
      }
      &:nth-child(2) {
        span {
          font-weight: 500;
          color: #262b2f;
          &:nth-child(1) {
            font-size: 16px;
          }
          &:nth-child(2) {
            font-size: 14px;
          }
        }
      }
      &:nth-child(3) {
        color: #5D5D5D;
        font-weight: 400;
        font-size: 14px;
        span {
          &:nth-child(1) {
          }
          &:nth-child(2) {

          }
        }
      }
    }
    .p-span {
      margin-left: 15px;
    }

    /deep/ .el-select {
      width: 98% !important;
    }
    .cust-num /deep/ .el-input-number--medium {
      width: 98% !important;
    }
  }
  .cart-btn,.inactive-sku {
    margin-top: 15px;
    width: 98%;
    background: #262b2f;
    color: #ffffff;
    font-size: 14px;
    text-align: center;
    font-weight: 500;
    line-height: 36px;
    cursor: pointer;
  }
  .out-of-stock{
    margin-top: 15px;
    color: #5D5D5D;
    div:nth-child(1){
      font-size: 12px;
    }
    div:nth-child(2){
      margin-top: 5px;
      color: #FFFFFF;
      cursor: not-allowed;
    }
  }
  .inactive-sku{
    margin-top: 15px;
    color: #FFFFFF;
    background: #5D5D5D;
    cursor: not-allowed;
  }
  /deep/ .el-input__inner {
    border: 1px solid #e1e1e1 !important;
  }
  /deep/ .el-icon-plus {
    color: black !important;
  }
  /deep/ .el-icon-minus {
    color: black !important;
  }

  .right-content-mobile {
    width: 88vw;
    margin-left: 30px;
    position: relative;
    color: #262b2f;
     .p-span {
      margin-right: 15px;
    }
    p {
      line-height: 28px;
      &:nth-child(1) {
        font-size: 16px;
        font-weight: 800;
      }
      &:nth-child(2) {
        span {
          &:nth-child(2) {
            font-size: 16px;
            font-weight: 500;
            color: #262b2f;
          }
          &:nth-child(1) {
            font-size: 14px;
            font-weight: 500;
            color: #5d5d5d;
          }
        }
      }
      &:nth-child(3) {
        color: #ff4812;
        span {
          &:nth-child(2) {
            font-size: 20px;
            font-weight: 800;
          }
          &:nth-child(1) {
            font-size: 14px;
            font-weight: 500;
          }
        }
      }
      &.sku-attr,
      &.cust-num {
        margin-top: 20px;
        span {
          display: inline-block;
          width: 70px;
        }
      }

      &.cart-btn {
        width: 85% !important;
      }
      /deep/ .el-select {
        width: 65vw !important;
      }

      &.cust-num /deep/ .el-input-number--medium {
        width: 66vw !important;
        margin-left: 2px !important;
      }
    }
  }
}

.flex-col{
  display: flex  !important;
  flex-flow: column;
  align-items: start !important;
  .wholesale-price-span,.price_name{
    margin: 0 !important;
  }
}

.original-price {
  text-decoration: line-through;
  font-size: 14px;
  font-family: Satoshi;
  font-weight: 400;
  color: #262B2F;
  margin-left: 5px;
}
@media screen and (max-width: 600px) {
  .brand_img_url{
    width: 24px;
    height: 24px;
  }
  .top_brand_mobile{
    margin-bottom: 5px;
    width: 70px;
    height: 20px;
    background: #FFEBE5;
    border-color: #FFEBE5;
    border-radius: 3px;
    font-size: 12px;
    font-family: Satoshi-Medium;
    font-weight: 500;
    line-height: 20px;
    color: #FB541C;
    text-align: center;
  }
  .wholesale{
    display: none;
  }
  .card-list {
    box-sizing: border-box;
    padding: 0px;
    // padding: 0 10px;
    margin-left: 0;
    width: 100%;
    justify-content: space-between;
    .card1 {
      margin-right:0px;
      margin:0px 5px;
    }
    .card3,
    .card4,
    .card5 {
      width: 48%;
      margin-right: 0;
      margin-bottom: 10px !important;
      p {
        span {
          font-size: 12px;
        }
      }
    }
    .goods {
      height: 185px;
    }
    .card .h3 {
      display: block;
      text-align: left;
      b {
        display: block;
        width: 100%;
        margin: 0;
      }
    }
    .card{
      .h5{
        font-size: 14px;
        margin:10px 0 0;
        height: 38px;
      }
      .h3{
        .price_h3{
          font-size: 12px ;
        }
        .price_name{
          font-size: 12px ;
        }
      }
      .not_login_lock{
        .lock_content{
          font-size: 12px;
        }
        width: 100% !important;
      }


    }
  }
  .wap-p {
    width: 100%;
    overflow: auto;
  }
}
@media screen and (max-width: 600px) {
  .action-area {
    h4 {
      opacity: 0 !important;
      width: 80% !important;
      height: 35px !important;
      line-height: 35px !important;
      left: 9% !important;
      &:nth-child(1) {
        bottom: 45px !important;
      }
      &:nth-child(2) {
        bottom: 5px !important;
      }
    }
  }
  .card-list{
    .card{
      .h3{
        width: 100% !important;
      }
    }
  }
  .card {
    &:hover {
      .goods h4 {
        opacity: 1 !important;
        transition: all 0.5s !important;
        text-align: center;
      }
    }
  }

  /deep/ .el-dialog {
    width: 100vw !important;
  }
  .dia-content {
    flex-wrap: wrap !important;
    .left-content {
      width: 90vw !important;
      height: 90vw !important;
    }
  }
  .wholesale-price-span{
    font-size: 12px;
  }
  .wholesale-price-span,.price_name{
    margin: 0px !important;
  }

}
.style_quantity{
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/components/card.vue